import { useCallback } from 'react';
import { useResolveParentsByChildren } from './resolve-parents-by-children';
import { useSetParentWorkItemToInProgress } from './set-parent-work-item-to-in-progress';
import { useSetParentWorkItemToInProgressUnlessResolved } from './set-parent-work-item-to-in-progress-unless-is-resolved';
import { useResolveChildrenWhenParentIsResolved } from './resolve-children-when-parent-is-resolved';
import { useApplyChangesForAllChildrenWhenParentIterationIsUpdated } from './apply-changes-for-all-children-when-iteration-parent-is-updated';
import { useApplyChangesForAllChildrenWhenParentPriorityIsUpdated } from './apply-changes-for-all-children-when-priority-parent-id-updated';
import { useCopyIterationPathFromParentWiWhenWiIsCreated } from './copy-iterationpath-from-parent-wi-when-wi-is-created';

export function useTemplatesDialogHandlers() {
	const { resolveParentsByChildren } = useResolveParentsByChildren();
	const { setParentWorkItemToInProgress } = useSetParentWorkItemToInProgress();
	const { setParentWorkItemToInProgressUnlessResolved } = useSetParentWorkItemToInProgressUnlessResolved();
	const { resolveChildrenWhenParentIsResolved } = useResolveChildrenWhenParentIsResolved();
	const { applyChangesForAllChildrenWhenParentIterationIsUpdated } = useApplyChangesForAllChildrenWhenParentIterationIsUpdated();
	const { applyChangesForAllChildrenWhenParentPriorityIsUpdated } = useApplyChangesForAllChildrenWhenParentPriorityIsUpdated();
	const { copyIterationPathFromParentWiWhenWiIsCreated } = useCopyIterationPathFromParentWiWhenWiIsCreated();

	const callTemplateAndMountForm = useCallback((templateId: string) => {
		switch (templateId) {
		case '1':
			resolveParentsByChildren();
			break;
		case '2':
			setParentWorkItemToInProgress();
			break;
		case '3':
			setParentWorkItemToInProgressUnlessResolved();
			break;
		case '4':
			resolveChildrenWhenParentIsResolved();
			break;
		case '5':
			applyChangesForAllChildrenWhenParentIterationIsUpdated();
			break;
		case '6':
			applyChangesForAllChildrenWhenParentPriorityIsUpdated();
			break;
		case '7':
			copyIterationPathFromParentWiWhenWiIsCreated();
			break;
		default:
			break;
		}
	}, []);

	return {
		callTemplateAndMountForm
	};
}